export const test_types = [
    { code: 'Transcription', label: 'Transcription' },
    { code: 'Annotation', label: 'Annotation' },
    { code: 'YesNo', label: 'YesNo' },
    { code: 'Translation', label: 'Translation' },
    { code: 'LanguageSkills', label: 'Language Skills' },
    // { code: 'Voice Collection Validator', label: 'Voice Collection Validator' },
];
